module.exports = "<div class=\"iframe-container--responsive\">\n    <iframe *ngIf=\"videoId\" width=\"560\" height=\"315\"  [src]=\"safeUrl\" frameborder=\"0\" allowfullscreen></iframe>\n    <iframe *ngIf=\"!videoId\" width=\"560\" height=\"315\" [src]=\"safeUrl\" frameborder=\"0\" allowfullscreen></iframe>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/ui-helper/youtube-iframe/youtube-iframe.html
// module id = yO4Q
// module chunks = 12